const cookiePolicyCheckbox = document.getElementById(
  'cookie-policy__cookie-checkbox'
);
const ageGateConfirmation = document.getElementById('age-gate-confirmation');

if (cookiePolicyCheckbox) {
  if (!cookiePolicyCheckbox.checked) {
    // initially disable the age gate confirmation
    ageGateConfirmation.setAttribute('disabled', true);
  }

  cookiePolicyCheckbox.addEventListener('change', e => {
    const checkbox = e.target;
    if (checkbox.checked) {
      ageGateConfirmation.removeAttribute('disabled');
    } else {
      ageGateConfirmation.setAttribute('disabled', true);
    }
  });
}
